import { 
  FaCode, 
  FaMobile, 
  FaDatabase,
  FaCloud, 
  FaChartBar, 
  FaCogs, 
  FaCheckCircle, 
  FaLightbulb,
  FaServer,
  FaShieldAlt,
  FaNetworkWired,
  FaBrain,
  FaRobot,
  FaCloudversify,
  FaPlug,
  FaWindows
} from 'react-icons/fa';
import { 
  BiData,
  BiGitBranch,
  BiTransfer
} from 'react-icons/bi';
import { 
  AiOutlineCloudServer,
  AiOutlineApartment,
  AiOutlineApi,
  AiOutlineAudit
} from 'react-icons/ai';
import { 
  DiAws,
  DiDocker,
  DiGoogleCloudPlatform,
  DiMsqlServer
} from 'react-icons/di';
import { 
  SiSalesforce, 
  SiSap 
} from 'react-icons/si';
import styled, { css } from 'styled-components';
import { Container } from '../../components/Grid/Container';
import { Typography } from '../../components/Typography';
import { Button } from '../../components/Button/Button';
import { Card, CardGrid, CardHeader, CardContent } from '../../components/Card/Card';
import { useNavigate } from 'react-router-dom';
import { useGTM } from '../../hooks/useGTM';
import { useEffect } from 'react';

const HeroTitle = styled(Typography)`
  ${({ theme }) => css`
    font-size: 3em;
    text-align: left;
    line-height: 1.2;

    @media (max-width: 768px) {
      font-size: 2em;
    }
  `}
  font-family: ${({ theme }) => theme.typography.fontFamily.heading};
  margin-bottom: 20px;
  font-weight: 700;
`;

const HeroDescription = styled(Typography)`
  font-family: ${({ theme }) => theme.typography.fontFamily.body};
  font-size: 18px;
  margin-bottom: 20px;
  font-weight: 400;
`;

const HeroSection = styled.section`
  padding: ${({ theme }) => theme.spacing.xl} 0;
  min-height: calc(100vh - 80px);
  display: flex;
  align-items: center;
  position: relative;
  overflow: hidden;

  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: ${({ theme }) => theme.effects.circuitPattern};
    opacity: 0.1;
    animation: pulse 4s ease-in-out infinite;
  }

  &::after {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: ${({ theme }) => theme.colors.background.overlay};
    pointer-events: none;
  }

  @keyframes pulse {
    0% { opacity: 0.05; }
    50% { opacity: 0.15; }
    100% { opacity: 0.05; }
  }
`;

const services = [
  {
    title: "Desenvolvimento Web",
    description: "Criamos websites e aplicações web modernas, responsivas e otimizadas para performance.",
    icon: FaCode,
    color: "#00B2FF"
  },
  {
    title: "Aplicativos Mobile",
    description: "Desenvolvemos aplicativos nativos e híbridos para iOS e Android com foco na experiência do usuário.",
    icon: FaMobile,
    color: "#7FF1FF"
  },
  {
    title: "Arquitetura de Software",
    description: "Projetamos arquiteturas escaláveis, seguras e de alta performance para seus sistemas.",
    icon: AiOutlineApartment,
    color: "#0080B3"
  },
  {
    title: "Soluções em Cloud",
    description: "Implementamos e gerenciamos infraestrutura em nuvem com AWS, Azure e Google Cloud.",
    icon: AiOutlineCloudServer,
    color: "#00B2FF"
  },
  {
    title: "Data Analytics",
    description: "Transformamos dados em insights valiosos para tomada de decisões estratégicas.",
    icon: FaChartBar,
    color: "#7FF1FF"
  },
  {
    title: "Engenharia de Dados",
    description: "Construímos pipelines de dados robustos e escaláveis para processamento em larga escala.",
    icon: BiData,
    color: "#0080B3"
  },
  {
    title: "Quality Assurance",
    description: "Garantimos a qualidade do seu software com testes automatizados e processos ágeis.",
    icon: FaCheckCircle,
    color: "#00B2FF"
  },
  {
    title: "DevOps",
    description: "Automatizamos processos de desenvolvimento e implantação com as melhores práticas do mercado.",
    icon: DiDocker,
    color: "#7FF1FF"
  },
  {
    title: "Segurança da Informação",
    description: "Implementamos soluções robustas para proteger seus dados e sistemas.",
    icon: FaShieldAlt,
    color: "#0080B3"
  },
  {
    title: "Microsserviços",
    description: "Desenvolvemos arquiteturas distribuídas e escaláveis baseadas em microsserviços.",
    icon: FaNetworkWired,
    color: "#00B2FF"
  },
  {
    title: "Banco de Dados",
    description: "Projetamos e otimizamos estruturas de dados para alto desempenho.",
    icon: FaDatabase,
    color: "#7FF1FF"
  },
  {
    title: "Consultoria em TI",
    description: "Oferecemos consultoria especializada para ajudar sua empresa a tomar as melhores decisões tecnológicas.",
    icon: FaLightbulb,
    color: "#0080B3"
  },
  {
    title: "Cloud AWS",
    description: "Especialistas em soluções Amazon Web Services para sua infraestrutura em nuvem.",
    icon: DiAws,
    color: "#00B2FF"
  },
  {
    title: "Integração Contínua",
    description: "Implementamos pipelines de CI/CD para entregas ágeis e confiáveis.",
    icon: BiGitBranch,
    color: "#7FF1FF"
  },
  {
    title: "Machine Learning",
    description: "Desenvolvemos soluções inteligentes usando algoritmos de aprendizado de máquina.",
    icon: FaBrain,
    color: "#0080B3"
  },
  {
    title: "Inteligência Artificial",
    description: "Desenvolvemos soluções avançadas com IA para automatização e otimização de processos.",
    icon: FaRobot,
    color: "#00B2FF"
  },
  {
    title: "Processamento de Linguagem Natural",
    description: "Implementamos soluções de NLP para análise de texto e interação em linguagem natural.",
    icon: FaBrain,
    color: "#7FF1FF"
  },
  {
    title: "Integração com SAP",
    description: "Realizamos integrações complexas com sistemas SAP e desenvolvimento de add-ons.",
    icon: SiSap,
    color: "#0080B3"
  },
  {
    title: "Integração com Salesforce",
    description: "Desenvolvemos soluções personalizadas e integrações com Salesforce CRM.",
    icon: SiSalesforce,
    color: "#00B2FF"
  },
  {
    title: "APIs e Integrações",
    description: "Criamos e integramos APIs RESTful para conectar diferentes sistemas e plataformas.",
    icon: AiOutlineApi,
    color: "#7FF1FF"
  },
  {
    title: "Middleware e ESB",
    description: "Implementamos soluções de middleware para integração de sistemas legados e modernos.",
    icon: BiTransfer,
    color: "#0080B3"
  },
  {
    title: "Assessment Cloud AWS",
    description: "Avaliamos sua infraestrutura e planejamos migrações otimizadas para AWS.",
    icon: DiAws,
    color: "#00B2FF"
  },
  {
    title: "Assessment Cloud Azure",
    description: "Análise completa de ambiente e estratégias de migração para Microsoft Azure.",
    icon: FaWindows,
    color: "#7FF1FF"
  },
  {
    title: "Assessment Google Cloud",
    description: "Avaliação de infraestrutura e planejamento de migração para Google Cloud Platform.",
    icon: DiGoogleCloudPlatform,
    color: "#0080B3"
  },
  {
    title: "Multi-Cloud Strategy",
    description: "Desenvolvemos estratégias para gerenciamento eficiente de ambientes multi-cloud.",
    icon: FaCloudversify,
    color: "#00B2FF"
  },
  {
    title: "Integrações Legacy",
    description: "Conectamos sistemas legados com novas tecnologias mantendo a estabilidade do negócio.",
    icon: FaPlug,
    color: "#7FF1FF"
  },
  {
    title: "Auditoria de Sistemas",
    description: "Realizamos auditorias técnicas completas em sistemas e infraestrutura.",
    icon: AiOutlineAudit,
    color: "#0080B3"
  }
];

const ServicesSection = styled.section`
  padding: ${({ theme }) => theme.spacing['2xl']} 0;
  background: ${({ theme }) => theme.colors.background.darker};
  position: relative;
  overflow: hidden;

  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: ${({ theme }) => theme.effects.circuitPattern};
    opacity: 0.1;
    animation: pulse 4s ease-in-out infinite;
  }

  &::after {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: ${({ theme }) => theme.colors.background.overlay};
    pointer-events: none;
  }
`;

const ServicesGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: ${({ theme }) => theme.spacing.xl};
  margin-top: ${({ theme }) => theme.spacing.xl};

  @media (max-width: 480px) {
    grid-template-columns: 1fr;
  }
`;

const ServiceCard = styled(Card)`
  transition: all 0.3s ease;
  box-shadow: ${({ theme }) => theme.effects.glow};
  background: ${({ theme }) => theme.effects.glassMorphism};
  border: 1px solid rgba(0, 178, 255, 0.15);
  
  &:hover {
    transform: translateY(-8px);
    box-shadow: 0 8px 30px ${({ theme }) => theme.colors.primary.main}30;
    border-color: ${({ theme }) => theme.colors.primary.main}40;
  }
`;

const ServiceIcon = styled.div<{ color: string }>`
  font-size: 2.5rem;
  margin-bottom: ${({ theme }) => theme.spacing.md};
  color: ${({ color }) => color};
  
  svg {
    filter: drop-shadow(0 0 8px ${({ color }) => color}40);
    transition: transform 0.3s ease;
  }

  ${ServiceCard}:hover & svg {
    transform: scale(1.1);
  }
`;

const HeroContent = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: ${({ theme }) => theme.spacing.xl};
  align-items: center;

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
    gap: ${({ theme }) => theme.spacing.lg};
  }
`;

const HeroText = styled.div`
  position: relative;
  z-index: 1;

  h1 {
    font-size: ${({ theme }) => theme.typography.sizes['5xl']};
    font-weight: ${({ theme }) => theme.typography.weight.bold};
    line-height: ${({ theme }) => theme.typography.lineHeight.tight};
    margin-bottom: ${({ theme }) => theme.spacing.md};
    background: ${({ theme }) => theme.colors.primary.gradient};
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    animation: fadeIn 0.8s ease-out;
    
    @media (max-width: 768px) {
      font-size: ${({ theme }) => theme.typography.sizes['3xl']};
    }
  }

  p {
    font-size: ${({ theme }) => theme.typography.sizes.xl};
    line-height: ${({ theme }) => theme.typography.lineHeight.relaxed};
    margin-bottom: ${({ theme }) => theme.spacing.lg};
    animation: slideUp 0.8s ease-out;
    
    @media (max-width: 768px) {
      font-size: ${({ theme }) => theme.typography.sizes.lg};
    }
  }

  @keyframes fadeIn {
    from { opacity: 0; }
    to { opacity: 1; }
  }

  @keyframes slideUp {
    from {
      opacity: 0;
      transform: translateY(20px);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }
`;

const HeroImage = styled.div`
  img {
    width: 100%;
    max-width: 500px;
    margin: 0 auto;
    display: block;
  }

  @media (max-width: 768px) {
    order: -1;
    img {
      max-width: 300px;
    }
  }
`;

const ButtonGroup = styled.div`
  display: flex;
  gap: ${({ theme }) => theme.spacing.md};
  margin-top: ${({ theme }) => theme.spacing.xl};

  @media (max-width: 480px) {
    flex-direction: column;
    width: 100%;
    
    button {
      width: 100%;
    }
  }
`;

const ServiceModelTitle = styled(Typography)`
  margin-bottom: ${({ theme }) => theme.spacing.md};
`;

const ServiceModelCard = styled(Card)`
  padding: ${({ theme }) => theme.spacing.lg};
  transition: all 0.3s ease;
  height: 100%;
  background: ${({ theme }) => theme.effects.glassMorphism};
  box-shadow: ${({ theme }) => theme.effects.glow};
  border: 1px solid rgba(0, 178, 255, 0.15);

  &:hover {
    transform: translateY(-5px);
    border-color: ${({ theme }) => theme.colors.primary.main}40;
    box-shadow: 0 8px 30px ${({ theme }) => theme.colors.primary.main}30;
  }

  h3 {
    color: ${({ theme }) => theme.colors.primary.main};
    margin-bottom: ${({ theme }) => theme.spacing.md};
    font-family: ${({ theme }) => theme.typography.fontFamily.heading};
    font-weight: ${({ theme }) => theme.typography.weight.semibold};
  }

  ul {
    list-style: none;
    padding: 0;
    margin: 0;
    color: ${({ theme }) => theme.colors.text.secondary};
  }

  li {
    margin-bottom: ${({ theme }) => theme.spacing.sm};
    display: flex;
    align-items: flex-start;
    gap: ${({ theme }) => theme.spacing.sm};

    &:before {
      content: "•";
      color: ${({ theme }) => theme.colors.primary.main};
    }
  }
`;

const ServiceModelsGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: ${({ theme }) => theme.spacing.lg};
  margin-top: ${({ theme }) => theme.spacing.xl};
`;

const ServiceModelsSection = styled.section`
  background: ${({ theme }) => theme.colors.background.darker};
  padding: ${({ theme }) => theme.spacing['2xl']} 0;
  position: relative;
  overflow: hidden;

  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: ${({ theme }) => theme.effects.circuitPattern};
    opacity: 0.1;
    animation: pulse 4s ease-in-out infinite alternate;
  }

  &::after {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: ${({ theme }) => theme.colors.background.overlay};
    pointer-events: none;
  }
`;

export const Home = () => {
  const navigate = useNavigate();
  const { pushEvent } = useGTM();

  useEffect(() => {
    pushEvent('page_view', {
      page_title: 'Home',
      page_path: '/'
    });
  }, []);

  const handlePortfolioClick = () => {
    pushEvent('cta_click', {
      action: 'portfolio',
      page: 'home',
      button_text: 'Ver Portfolio'
    });
    navigate('/portfolio');
  };

  const handleContactClick = () => {
    pushEvent('cta_click', {
      action: 'contact',
      page: 'home',
      button_text: 'Contato'
    });
    navigate('/contact');
  };

  return (
    <main>
      <HeroSection aria-label="Seção principal">
        <Container>
          <HeroContent>
            <HeroText>
              <HeroTitle $variant="h3" $gradient>
                Tecnologia que Resolve. Inovação que Impulsiona.
              </HeroTitle>
              <HeroDescription $variant="body1" $color="secondary">
                Na Fagundes.tech, combinamos expertise e visão de futuro para criar soluções inteligentes, flexíveis e eficientes. Transformamos desafios em oportunidades e tecnologia em vantagem competitiva. Simples, estratégico e sob medida para o seu negócio.
              </HeroDescription>
              <ButtonGroup role="group" aria-label="Ações principais">
                <Button 
                  $variant="primary" 
                  size="large"
                  onClick={handlePortfolioClick}
                >
                  Ver Portfolio
                </Button>
                <Button 
                  $variant="outline" 
                  size="large"
                  onClick={handleContactClick}
                >
                  Contato
                </Button>
              </ButtonGroup>
            </HeroText>
            <HeroImage>
              <img 
                src="/images/hero-illustration.svg" 
                alt="Transformação Digital" 
              />
            </HeroImage>
          </HeroContent>
        </Container>
      </HeroSection>

      <ServicesSection aria-label="Nossos serviços">
        <Container>
          <Typography $variant="h2" $gradient $align="center">
            Nossos Serviços
          </Typography>
          <Typography $variant="body1" $color="secondary" $align="center">
            Soluções completas para transformar seu negócio
          </Typography>
          
          <ServicesGrid role="list" aria-label="Lista de serviços">
            {services.map((service, index) => {
              const IconComponent = service.icon;
              return (
                <ServiceCard key={index} $variant="glass" $hoverable>
                  <ServiceIcon color={service.color}>
                    <IconComponent />
                  </ServiceIcon>
                  <Typography $variant="h4" $gradient>
                    {service.title}
                  </Typography>
                  <Typography $variant="body1" $color="secondary">
                    {service.description}
                  </Typography>
                </ServiceCard>
              );
            })}
          </ServicesGrid>
        </Container>
      </ServicesSection>

      <ServiceModelsSection aria-label="Modalidades de contratação">
        <Container>
          <Typography $variant="h2" $gradient $align="center">
            Modalidades de Contratação
          </Typography>
          <Typography $variant="body1" $color="secondary" $align="center">
            Soluções flexíveis para diferentes necessidades
          </Typography>

          <ServiceModelsGrid role="list" aria-label="Lista de modalidades de contratação">
            <ServiceModelCard $variant="glass">
              <ServiceModelTitle $variant="h4" $gradient>Body Shop</ServiceModelTitle>
              <ul>
                <li>Profissionais dedicados para seu time</li>
                <li>Flexibilidade na gestão dos recursos</li>
                <li>Escala sob demanda</li>
                <li>Contratação por hora ou mensalidade</li>
                <li>Ideal para times ágeis</li>
              </ul>
            </ServiceModelCard>

            <ServiceModelCard $variant="glass">
              <ServiceModelTitle $variant="h4" $gradient>Projeto Fechado</ServiceModelTitle>
              <ul>
                <li>Escopo e orçamento definidos</li>
                <li>Prazo estabelecido</li>
                <li>Gestão completa do projeto</li>
                <li>Garantia de entrega</li>
                <li>Ideal para projetos específicos</li>
              </ul>
            </ServiceModelCard>

            <ServiceModelCard $variant="glass">
              <ServiceModelTitle $variant="h4" $gradient>Squad as a Service</ServiceModelTitle>
              <ul>
                <li>Time multidisciplinar completo</li>
                <li>Autonomia e auto-gestão</li>
                <li>Metodologias ágeis</li>
                <li>Entregas contínuas</li>
                <li>Ideal para produtos digitais</li>
              </ul>
            </ServiceModelCard>

            <ServiceModelCard $variant="glass">
              <ServiceModelTitle $variant="h4" $gradient>Consultoria Especializada</ServiceModelTitle>
              <ul>
                <li>Assessoria técnica pontual</li>
                <li>Diagnóstico e recomendações</li>
                <li>Mentoria e capacitação</li>
                <li>Suporte na tomada de decisão</li>
                <li>Ideal para direcionamento estratégico</li>
              </ul>
            </ServiceModelCard>
          </ServiceModelsGrid>
        </Container>
      </ServiceModelsSection>
    </main>
  );
}; 